var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJustifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9,11h-5v-2h5v2Zm13.562,12.976l-3.089-3.089c-.981.698-2.177,1.113-3.473,1.113-3.314,0-6-2.686-6-6s2.686-6,6-6,6,2.686,6,6c0,1.296-.415,2.492-1.113,3.473l3.089,3.089-1.414,1.414Zm-5.81-5.537l3.607-3.696-1.398-1.43-3.614,3.703-2.216-2.301-1.387,1.441,2.182,2.268c.766.765,2.079.763,2.823.019l.004-.004Zm-12.752-5.44v2h4.062c.087-.699.265-1.369.52-2h-4.582Zm0,4v2h4.582c-.255-.631-.433-1.301-.52-2h-4.062Zm6.709,5c1.41,1.245,3.262,2,5.291,2H0V3C0,1.346,1.346,0,3,0h9.414l7.586,7.586v1.414h-9V2H3c-.551,0-1,.449-1,1v19h8.709Zm2.291-15h3.586l-3.586-3.586v3.586Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJustifications);
export default __webpack_public_path__ + "static/media/icon-justifications.5801b75444c085f349d81eed66a2a52b.svg";
export { ForwardRef as ReactComponent };